import { PaymentInputOption } from './constants/quotes';

// eslint-disable-next-line import/prefer-default-export
export const validateTermAndInitialPayment = (
  values,
  setFieldError,
  data,
  t,
  isMsiModality = false,
  isFirstUpfrontRentModality = false
) => {
  let validated = true;

  const minInitialPayment = isMsiModality
    ? data.minMsiInitialPayment
    : data.minInitialPaymentPercentage;

  if (!isFirstUpfrontRentModality) {
    if (values.paymentInputOption === PaymentInputOption.AMOUNT) {
      if (
        values.initialPayment >
        (Number(values.price) * Number(data.maxInitialPaymentPercentage)) / 100
      ) {
        setFieldError(
          'initialPayment',
          t('QUOTES_VIEW.QUICK_QUOTE_FORM.INITIAL_PAYMENT_EXCEEDED').replace(
            '{amount}',
            data.maxInitialPaymentPercentage
          )
        );
        validated = false;
      }

      if (
        values.initialPayment <
        (Number(values.price) * Number(minInitialPayment)) / 100
      ) {
        setFieldError(
          'initialPayment',
          t('QUOTES_VIEW.QUICK_QUOTE_FORM.INITIAL_PAYMENT_LOWER').replace(
            '{amount}',
            minInitialPayment
          )
        );
        validated = false;
      }
    } else if (values.paymentInputOption === PaymentInputOption.PERCENTAGE) {
      if (values.initialPayment > Number(data.maxInitialPaymentPercentage)) {
        setFieldError(
          'initialPayment',
          t('QUOTES_VIEW.QUICK_QUOTE_FORM.INITIAL_PAYMENT_EXCEEDED').replace(
            '{amount}',
            data.maxInitialPaymentPercentage
          )
        );
        validated = false;
      }

      if (values.initialPayment < Number(minInitialPayment)) {
        setFieldError(
          'initialPayment',
          t('QUOTES_VIEW.QUICK_QUOTE_FORM.INITIAL_PAYMENT_LOWER').replace(
            '{amount}',
            minInitialPayment
          )
        );
        validated = false;
      }
    }

    if (values.initialPayment < Number(minInitialPayment)) {
      setFieldError(
        'initialPayment',
        t('QUOTES_VIEW.QUICK_QUOTE_FORM.INITIAL_PAYMENT_LOWER').replace(
          '{amount}',
          minInitialPayment
        )
      );
      validated = false;
    }
  }

  if (!isMsiModality) {
    if (values.term < data.minTerm) {
      setFieldError(
        'term',
        t('QUOTES_VIEW.QUICK_QUOTE_FORM.MIN_TERM').replace(
          '{term}',
          data.minTerm
        )
      );
      validated = false;
    }
    if (values.term > data.maxTerm) {
      setFieldError(
        'term',
        t('QUOTES_VIEW.QUICK_QUOTE_FORM.MAX_TERM').replace(
          '{term}',
          data.maxTerm
        )
      );
      validated = false;
    }
  }
  if (isMsiModality) {
    if (values.term < data.minMsiTerm) {
      setFieldError(
        'term',
        t('QUOTES_VIEW.QUICK_QUOTE_FORM.MIN_TERM').replace(
          '{term}',
          data.minTerm
        )
      );
      validated = false;
    }
    if (values.term > data.maxMsiTerm) {
      setFieldError(
        'term',
        t('QUOTES_VIEW.QUICK_QUOTE_FORM.MAX_TERM').replace(
          '{term}',
          data.maxMsiTerm
        )
      );
      validated = false;
    }
  }

  return validated;
};
